import { render, staticRenderFns } from "./todoData.vue?vue&type=template&id=12099d9c&scoped=true&"
import script from "./todoData.vue?vue&type=script&lang=js&"
export * from "./todoData.vue?vue&type=script&lang=js&"
import style0 from "./todoData.vue?vue&type=style&index=0&id=12099d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12099d9c",
  null
  
)

export default component.exports